/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
const __vue_script__ = {
    components: {
        full_loading: full_loading,
    },
    name: 'share_property_modal',
    props: {
    },
    data() {
        return {
            global,
            helper,
            frappe,
            is_loading: false,
            error: false,
            property_name: null,
            user_mobile:"",
            share_link:"",
            random:null,
            qrcode:null,
            onsuccess_func:null
        }
    },
    beforeMount(){
        console.log("beforeMount");
        this.property_name = null;
    },
    mounted() {     
        var exampleModal = document.getElementById('share-property-modal')
        exampleModal.addEventListener('show.bs.modal', this.load_property_data)
    },
    methods: {
        load_property_data: async function(event){
            this.share_link = null;
            this.user_mobile = null;
            console.log("load_property_data");
            var button = event.relatedTarget;
            this.property_name = button.getAttribute('data-bs-property-name');
            setTimeout(()=>{
                this.share_link = frappe.url+"/property/"+this.property_name;
                if(this.qrcode != null){
                    this.qrcode.clear();
                    this.qrcode.makeCode(frappe.url+"/property/"+this.property_name);
                }else{
                    this.qrcode = new QRCode("qrcode", {
                        text: frappe.url+"/property/"+this.property_name,
                        width: 128,
                        height: 128,
                        class: "inline-block",
                        colorDark : "#000000",
                        colorLight : "#ffffff",
                    });
                }
            }, 500);
        },
        copy_link: async function (){
            // Get the text field
            var copyText = document.getElementById("link-input");

            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices

            // Copy the text inside the text field
            navigator.clipboard.writeText(copyText.value);

            // Alert the copied text
            helper.showSuccess("Link copied");

        },
        share_property: async function (){
            if(this.is_loading){
                return;
            }
            if(this.user_mobile.length != 10){
                helper.showException("Please enter valid mobile no");
                return;
            }
            this.loading = true;
            global.emitter.emit("show-full-loading");
            let params = {
                property_name: this.property_name,
                to_user: this.user_mobile,
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.share_property",
                    type: "POST",
                    // data: params //for GET request
                    data: JSON.stringify(params) //for POST request
                });
                this.loading = false
                this.error = false;
                $("#share-property-modal").modal('hide');
                helper.showSuccess("Property shared successfully");
            } catch (e) {
                this.error = true;
                helper.showException(e,()=>{
                    // $("#share-property-modal").modal('hide');
                });
            }
            global.emitter.emit("hide-full-loading");
            this.loading = false
        }
    },
    computed: {
    }
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "share-property-modal",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                {
                  staticClass: "modal-title",
                  attrs: { id: "staticBackdropLabel" }
                },
                [_vm._v(_vm._s(_vm.helper.t("Share Property")))]
              ),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-3 text-end mt-2" }, [
                  _vm.property_name != null
                    ? _c("div", { attrs: { id: "qrcode" } })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 border-start" }, [
                  _c(
                    "div",
                    {
                      staticClass: "row justify-content-start align-items-end"
                    },
                    [
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", { staticClass: "form-group m-0" }, [
                          _c("label", { staticClass: "m-0" }, [
                            _vm._v(_vm._s(_vm.helper.t("Copy the link below")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.share_link,
                                expression: "share_link"
                              }
                            ],
                            staticClass: "form-control border-radius",
                            staticStyle: { height: "41px" },
                            attrs: {
                              id: "link-input",
                              type: "text",
                              readonly: ""
                            },
                            domProps: { value: _vm.share_link },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.share_link = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-start" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { role: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.copy_link()
                                  }
                                }
                              },
                              [_c("p", [_vm._v(_vm._s(_vm.helper.t("Copy")))])]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-start align-items-end mb-"
                    },
                    [
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", { staticClass: "form-group m-0 mt-3" }, [
                          _c("label", { staticClass: "m-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm.helper.t("Share it with a Maalek user")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user_mobile,
                                expression: "user_mobile"
                              }
                            ],
                            staticClass: "form-control border-radius",
                            staticStyle: { height: "41px" },
                            attrs: {
                              type: "text",
                              name: "user-name",
                              placeholder: "05xxxxxxxx",
                              autocomplete: "on"
                            },
                            domProps: { value: _vm.user_mobile },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.user_mobile = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-3" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-start" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { role: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.share_property()
                                  }
                                }
                              },
                              [_c("p", [_vm._v(_vm._s(_vm.helper.t("Share")))])]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-eaf81a9e_0", { source: "\n.modal-content{\n    overflow: visible !important;\n}\n.modal-body{\n    overflow: unset !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/modal/share-property-modal.vue"],"names":[],"mappings":";AAqLA;IACA,4BAAA;AACA;AACA;IACA,0BAAA;AACA","file":"share-property-modal.vue","sourcesContent":["<template>\r\n    <div class=\"modal fade filter-popup-area\" id=\"share-property-modal\" data-bs-backdrop=\"static\"\r\n    data-bs-keyboard=\"false\" tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n        <div class=\"modal-dialog modal-dialog-centered modal-dialog-scrollable\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <h5 class=\"modal-title\" id=\"staticBackdropLabel\">{{ helper.t(\"Share Property\") }}</h5>\r\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                </div>\r\n                <div class=\"modal-body\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-3 text-end mt-2\">\r\n                            <div v-if=\"property_name!=null\" id=\"qrcode\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-9 border-start\">\r\n                            <div class=\"row justify-content-start align-items-end\">\r\n                                <div class=\"col-9\">\r\n                                    <div class=\"form-group m-0\">\r\n                                        <label class=\"m-0\">{{ helper.t(\"Copy the link below\") }}</label>\r\n                                        <input id=\"link-input\" v-model=\"share_link\" type=\"text\" readonly class=\"form-control border-radius\" style=\"height:41px\">\r\n                                    </div>\r\n                                </div>\r\n                                <div class=\"col-3\">\r\n                                    <div class=\"d-flex justify-content-start\">\r\n                                        <a class=\"btn btn-primary\"\r\n                                            role=\"button\"\r\n                                            @click=\"copy_link()\">\r\n                                            <p>{{ helper.t(\"Copy\") }}</p>\r\n                                        </a>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"row justify-content-start align-items-end mb-\">\r\n                                <div class=\"col-9\">\r\n                                    <div class=\"form-group m-0 mt-3\">\r\n                                        <label class=\"m-0\">{{ helper.t(\"Share it with a Maalek user\") }}</label>\r\n                                        <input\r\n                                            class=\"form-control border-radius\"\r\n                                            style=\"height:41px\"\r\n                                            v-model=\"user_mobile\"\r\n                                            type=\"text\"\r\n                                            name=\"user-name\"\r\n                                            placeholder=\"05xxxxxxxx\"\r\n                                            autocomplete=\"on\"\r\n                                        />\r\n                                    </div>\r\n                                </div>\r\n                                <div class=\"col-3\">\r\n                                    <div class=\"d-flex justify-content-start\">\r\n                                        <a class=\"btn btn-primary\"\r\n                                            role=\"button\"\r\n                                            @click=\"share_property()\">\r\n                                            <p>{{ helper.t(\"Share\") }}</p>\r\n                                        </a>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../js/global\";\r\nimport * as helper from \"../../js/helper\";\r\nimport full_loading from \"../components/full-loading.vue\";\r\nexport default {\r\n    components: {\r\n        full_loading: full_loading,\r\n    },\r\n    name: 'share_property_modal',\r\n    props: {\r\n    },\r\n    data() {\r\n        return {\r\n            global,\r\n            helper,\r\n            frappe,\r\n            is_loading: false,\r\n            error: false,\r\n            property_name: null,\r\n            user_mobile:\"\",\r\n            share_link:\"\",\r\n            random:null,\r\n            qrcode:null,\r\n            onsuccess_func:null\r\n        }\r\n    },\r\n    beforeMount(){\r\n        console.log(\"beforeMount\");\r\n        this.property_name = null;\r\n    },\r\n    mounted() {     \r\n        var exampleModal = document.getElementById('share-property-modal')\r\n        exampleModal.addEventListener('show.bs.modal', this.load_property_data)\r\n    },\r\n    methods: {\r\n        load_property_data: async function(event){\r\n            this.share_link = null;\r\n            this.user_mobile = null;\r\n            console.log(\"load_property_data\");\r\n            var button = event.relatedTarget;\r\n            this.property_name = button.getAttribute('data-bs-property-name');\r\n            setTimeout(()=>{\r\n                this.share_link = frappe.url+\"/property/\"+this.property_name;\r\n                if(this.qrcode != null){\r\n                    this.qrcode.clear();\r\n                    this.qrcode.makeCode(frappe.url+\"/property/\"+this.property_name);\r\n                }else{\r\n                    this.qrcode = new QRCode(\"qrcode\", {\r\n                        text: frappe.url+\"/property/\"+this.property_name,\r\n                        width: 128,\r\n                        height: 128,\r\n                        class: \"inline-block\",\r\n                        colorDark : \"#000000\",\r\n                        colorLight : \"#ffffff\",\r\n                    });\r\n                }\r\n            }, 500);\r\n        },\r\n        copy_link: async function (){\r\n            // Get the text field\r\n            var copyText = document.getElementById(\"link-input\");\r\n\r\n            // Select the text field\r\n            copyText.select();\r\n            copyText.setSelectionRange(0, 99999); // For mobile devices\r\n\r\n            // Copy the text inside the text field\r\n            navigator.clipboard.writeText(copyText.value);\r\n\r\n            // Alert the copied text\r\n            helper.showSuccess(\"Link copied\");\r\n\r\n        },\r\n        share_property: async function (){\r\n            if(this.is_loading){\r\n                return;\r\n            }\r\n            if(this.user_mobile.length != 10){\r\n                helper.showException(\"Please enter valid mobile no\");\r\n                return;\r\n            }\r\n            this.loading = true;\r\n            global.emitter.emit(\"show-full-loading\");\r\n            let params = {\r\n                property_name: this.property_name,\r\n                to_user: this.user_mobile,\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.share_property\",\r\n                    type: \"POST\",\r\n                    // data: params //for GET request\r\n                    data: JSON.stringify(params) //for POST request\r\n                });\r\n                this.loading = false\r\n                this.error = false;\r\n                $(\"#share-property-modal\").modal('hide');\r\n                helper.showSuccess(\"Property shared successfully\");\r\n            } catch (e) {\r\n                this.error = true;\r\n                helper.showException(e,()=>{\r\n                    // $(\"#share-property-modal\").modal('hide');\r\n                });\r\n            }\r\n            global.emitter.emit(\"hide-full-loading\");\r\n            this.loading = false\r\n        }\r\n    },\r\n    computed: {\r\n    }\r\n}\r\n</script>\r\n\r\n<style>\r\n    .modal-content{\r\n        overflow: visible !important;\r\n    }\r\n    .modal-body{\r\n        overflow: unset !important;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/share-property-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__